<template>
  <div>
    <ul :class="`nav nav-tabs ${navClass}`">
      <li :class="{'nav-item':true,'step-doing': tab.isActive, 'step-done':tab.isDone }" v-for="(tab,tabIndex) in tabs"
          v-bind:key="tab.name"
          v-if="(tab.type!='done' && tab.type!='registed')">
        <a :class="{
                'nav-link':true,
                'disabled':topNavDisabled
            }" href="#" @click.prevent="clickedTab(tabIndex)">
          <span>{{ tab.name }}</span>
        </a>
      </li>
    </ul>

    <slot></slot>

    <div :class="`wizard-buttons ${navClass}`" v-if="!(lastStepEnd && isCompleted)">

      <!-- <button v-if="currentActive == 0" type="button" class="btn btn-outline-primary" @click="goBack()">취소
      </button> -->


      <!-- 상품수정 -->
      <button v-if="isModifyMode" type="button" class="ml-1 btn btn-primary" @click="goGoodsList()">리스트</button>
      <button v-if="isModifyMode" type="button" class="ml-1 btn btn-primary" @click="saveGoods()"
              :disabled="currentActive > totalTabs - 1 || ( currentActive ==3 && tabs.length == 6)">
        저장
      </button>



      <!-- 신규상품 -->

      <button v-if="!isModifyMode" type="button" class="mr-1 btn btn-primary" :disabled="!currentActive > 0"
              @click="previousTab()">
        이전
      </button>
      <button v-if="!isModifyMode && currentActive != totalTabs-1" type="button" class="btn btn-primary"
              :disabled="currentActive > totalTabs - 1" @click="nextTab()">
        <span>다음</span>
      </button>


      <!--       신규상품임시저장 -->
      <button v-if="!isModifyMode && currentActive == totalTabs-1" type="button" class="btn btn-primary mr-1" @click="craftSaveGoods()">
        임시저장
      </button>

      <!-- 신규상품등록요청 -->
      <button v-if="!isModifyMode && currentActive == totalTabs-1" type="button" class="btn btn-primary" @click="registerGoods()">
        등록요청
      </button>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "form-wizard",
  props: {
    navClass: {
      default: "justify-content-center"
    },
    lastStepEnd: {
      default: false
    },
    topNavDisabled: {
      default: false
    },
    withValidate: {
      default: false
    },
    done: {
      type: Function,
      default: () => {
        console.log("called done!")
      },
    },


  },

  data() {
    return {
      isRegisted: false,
      isModifyMode: false,
      isReqModifyMode: false,
      goodsParamsId: null, //등록된 상품아이디
      registerId: null, //등록대기 상품아이디
      copyRegisterId: null,
      tabs: [],
      currentActive: 0,
      totalTabs: 0,
      isCompleted: false,
      stepped: true
    };
  },

  computed: {
    ...mapGetters(['goodsType'])
  },

  created() {
    this.tabs = this.$children;
  },
  mounted() {
    // console.log(this.goodsType);
    this.totalTabs = this.tabs.filter(x => x.type != "done").length;
    // console.log(this.totalTabs);

    //신규상품
    this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
    if(this.registerId !== null) {
      this.isReqModifyMode = true
    }

    //등록상품
    this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
    if(this.goodsParamsId !== null) {
      this.isModifyMode = true
    }


  },

  methods: {

    goBack() {
      this.$router.back()
    },

    tabStatusFix() {
      this.tabs.forEach((tab, tabIndex) => {
        let isDone = tab.isDone;
        if(!isDone) {
          isDone = this.currentActive > tabIndex;
        }
        tab.isDone = isDone;
        tab.isActive = false;
      });
    },

    clickedTab(tabIndex) {
      if(!this.topNavDisabled) {
        if(!(this.lastStepEnd && this.isCompleted)) {

          if(!this.isModifyMode || this.isReqModifyMode) {
            //등록모드 : isdone==true 페이지만 접근가능
            if(this.tabs[tabIndex].isDone) {
              this.currentActive = tabIndex;
              this.tabStatusFix();
              this.tabs[this.currentActive].isActive = true;
            }
          } else { //수정모드 : 전체페이지 접근가능
            this.currentActive = tabIndex;
            this.tabStatusFix();
            this.tabs[this.currentActive].isActive = true;
          }

        }
      }
    },

    previousTab() {
      this.currentActive--;
      this.tabStatusFix();
      this.tabs[this.currentActive].isActive = true;
    },

    nextTab() {

      let valid = false;
      if(this.withValidate) {
        valid = this.tabs[this.currentActive].validate();
        if(valid) this.tabs[this.currentActive].submit();
      }

      if(valid) {
        this.currentActive++;
        this.tabStatusFix();

        if(this.currentActive >= this.totalTabs) {
          // this.isCompleted = true;
          // const doneTab = this.tabs.find(x => x.type == "done");
          // if(doneTab)
          //   doneTab.isActive = true;
          // else
          //   this.tabs[this.currentActive - 1].isActive = true;
        } else {
          this.tabs[this.currentActive].isActive = true;
        }
      }
    },

    //임시저장
    craftSaveGoods() {
      console.log("craftSaveGoods");
      this.tabs[this.currentActive].isActive = true;
      this.$emit('callDone')

    },

    //등록신청
    registerGoods() {
      this.tabs[this.currentActive].isActive = true;
      this.$emit('register', true)
    },

    saveGoods() {
      this.tabs[this.currentActive].isActive = true;
      console.log(this.currentActive)
      /*
      0 : 상품유형
      1 : 상품소개
      2 : 사용조건
      3 : 옵션/가격
      4 : 판매정보
      5 : 노출정보
       */
      this.$emit('saveGoods', this.currentActive)
    },

    goGoodsList() {
      this.$router.push(`../goods-list`)

    }

  },
  watch: {
    goodsType(val) {
      // console.log(val);
      if(val == "Booking"){
        this.totalTabs = 4
      }
    },
  }
};
</script>
